<template>
  <el-dialog
    center
    class="dialog-warp"
    title="下载选项"
    :visible.sync="showDownload"
    width="30%"
    :close-on-click-modal="false"
  >
    <el-form :model="downloadFrom" label-width="100px">
      <el-form-item label="下载样式" prop>
        <el-radio-group v-model="downloadFrom.colourType">
          <el-radio :label="1">彩色</el-radio>
          <!--          <el-radio :label="0">黑白</el-radio>-->
        </el-radio-group>
      </el-form-item>
      <el-form-item label="下载格式">
        <el-radio-group v-model="downloadFrom.fileType">
          <el-radio :label="0">PDF</el-radio>
          <el-radio :label="2">JPG</el-radio>
          <el-radio :label="1">PNG</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <template slot="footer" class="dialog-footer">
      <el-button type="primary" plain @click="hideDownload">取 消</el-button>
      <el-button type="primary" @click="downLoadSelect">确 定</el-button>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'modal',
  data() {
    return {
      showDownload: false,
      downloadFrom: {
        colourType: 1,
        fileType: 0
      },
      selectCallback: null
    };
  },
  watch: {
    showDownload(val) {
      if (!val) {
        this.downloadFrom = {
          colourType: 1,
          fileType: 0
        };
      }
    }
  },
  methods: {
    openDownload() {
      this.showDownload = true;
    },
    hideDownload() {
      this.showDownload = false;
    },
    downLoadSelect() {
      const { selectCallback } = this;
      selectCallback && selectCallback(this);
    }
  }
};
</script>

<style lang="scss" scoped>
.dialog-warp {
  /deep/ .el-dialog {
    min-width: 360px;
    padding: 0 20px;
    .el-dialog__body {
      padding: 0;
      .el-radio {
        margin-right: 10px;
        display: inline-block;
      }
    }
    .el-dialog__footer {
      display: flex;
      justify-content: center;
      .el-button {
        flex: 1;
        max-width: 150px;
      }
    }
  }
}
</style>
